<template>
	<Transition name="fade-slide-tg">
		<div v-if="!loading">
			<FootballStatsList v-if="leagues.length > 0"
			   v-for="league of leagues"
	       class="w-full"
	       :key="`${league.league_id}`"
	       :league="league"
	       :matches="leagueMatches(league.league_matches)"
	       :show-date="true"
	       :show-finished="true"
         show-live-matches-h2h-button
         league-underline
         show-table-icon
	       show-odds show-hour/>
			<div v-else class="border-zt-light rounded-zt border">
				<p class="text-xs text-zt-more text-center font-normal w-full -leading-[0.18px] bg-zt-light-full py-2.5">
					Brak meczów do wyświetlania
				</p>
			</div>
		</div>
	</Transition>
</template>

<script>
import {DateTime, Interval} from "luxon";
import FootballStatsList from "../../blocks/FootballStatsList.vue";
import utils_mixin from "../../../mixins/utils_mixin";

export default {
	name: 'CountryMatches',
	components: {FootballStatsList},
	mixins: [utils_mixin],
	data() {
		return {
			maxStartDate: DateTime.now().startOf('day'),
			maxEndDate: DateTime.now().startOf('day').plus({days: 7}),
			leagues: [],
			loading: true
		}
	},
	computed: {
		leagueIds() {
			return JSON.parse(this.$attrs.leaguesIds) ?? [];
		}
	},
	mounted() {
		this.getMatches();
	},
	methods: {
		leagueMatches(matches) {
			let filteredMatches;
			filteredMatches = matches;
			return filteredMatches.sort( (a, b) => {
				if ( DateTime.fromSQL(a.date).equals(DateTime.fromSQL(b.date)) ) {
					let aName = a.localteam_shortname ? a.localteam_shortname : a.localteam_name;
					let bName = b.localteam_shortname ? b.localteam_shortname : b.localteam_name;
					return aName > bName ? 1 : -1;
				} else {
					return DateTime.fromSQL(a.date) > DateTime.fromSQL(b.date);
				}
			});
		},
		getMatches(){
			axios.post(BACKEND_DATA.data.ajaxUrl, {
				endpoint: 'api_get_football_matches',
				startDate: this.maxStartDate.toFormat('yyyy-MM-dd HH:mm:ss'),
				endDate: this.maxEndDate.endOf('day').toFormat('yyyy-MM-dd HH:mm:ss'),
				league_ids: this.leagueIds
			})
				.then(response => {
					if ( response.data.success && response.data.data.length !== 0 ) {
						this.leagues = response.data.data;
						this.leagues.sort((a, b) => +a.league_id - +b.league_id)
					} else {
						this.leagues = [];
					}
					this.loading = false;
					this.removePlaceholder('country-matches');
				})
		},
	}
}
</script>
<style>
.fade-slide-enter-active,
.fade-slide-leave-active,
.fade-slide-tg-enter-active,
.fade-slide-tg-leave-active {
	transition: all 0.5s ease;

}

.fade-slide-enter-from,
.fade-slide-leave-to,
.fade-slide-tg-enter-from,
.fade-slide-tg-leave-to {
	opacity: 0;
	transform: translateX(30px);
}

.fade-slide-tg-enter-active {
	transition-delay: .55s;
}
</style>
